module.exports = __webpack_public_path__ + "img/c_04.88e764c1.jpg";